var ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, DealHighlights, PRIMARY_MESSAGE_TIMEOUT_TOUCH;

require('../../groupon-deal-timer/responsive/common/helpers');

require('../../groupon-deal-timer/responsive/frontend/models/countdown_timer');

require('../../groupon-deal-timer/responsive/frontend/views/countdown_timer');

require('../../groupon-deal-timer/responsive/frontend/countdown_timer');

DealHighlights = window.DealHighlights != null ? window.DealHighlights : window.DealHighlights = {};

ACTIVATE_PRIMARY_MESSAGE_TIMEOUT = 2000;

PRIMARY_MESSAGE_TIMEOUT_TOUCH = 3000;

DealHighlights.rotateMessages = function(messagesContainer, loopMessages) {
  var currentMessage, maxHeight, messagesWrapper, nextMessage, primaryMessage, primaryMessageHeight, secondaryMessage, secondaryMessageHeight, switchMessage;
  if (loopMessages == null) {
    loopMessages = false;
  }
  messagesWrapper = messagesContainer.find('.ums-wrapper.pre-animate');
  currentMessage = primaryMessage = messagesContainer.find('.primary');
  nextMessage = secondaryMessage = messagesContainer.find('.secondary');
  primaryMessageHeight = primaryMessage.height();
  messagesWrapper.css('height', primaryMessageHeight + "px");
  maxHeight = primaryMessageHeight;
  if (secondaryMessage.length) {
    secondaryMessageHeight = secondaryMessage.height();
    maxHeight = Math.max(primaryMessageHeight, secondaryMessageHeight);
  }
  switchMessage = function() {
    var ref;
    messagesWrapper.css('height', maxHeight + "px").removeClass('pre-animate');
    currentMessage.addClass('fade-out').removeClass('fade-in');
    nextMessage.addClass('fade-in').removeClass('fade-out');
    if (loopMessages) {
      return ref = [nextMessage, currentMessage], currentMessage = ref[0], nextMessage = ref[1], ref;
    }
  };
  if (loopMessages) {
    return window.setInterval(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH + ACTIVATE_PRIMARY_MESSAGE_TIMEOUT);
  } else {
    return window.setTimeout(switchMessage, PRIMARY_MESSAGE_TIMEOUT_TOUCH);
  }
};

DealHighlights.init = function(arg, done) {
  var activateRotatingMessaging, bindHighlightLinksNavigation, dealHighlights, prepareWindowHandlers, scrollHandler, tiles;
  dealHighlights = arg.dealHighlights;
  if (!dealHighlights) {
    return;
  }
  tiles = dealHighlights.tiles;
  if (dealHighlights.leftTile || dealHighlights.middleTile || dealHighlights.rightTile) {
    tiles = [dealHighlights.leftTile, dealHighlights.middleTile, dealHighlights.rightTile].filter(function(a) {
      return a;
    });
  }
  activateRotatingMessaging = function($element, loopMessages) {
    if ($element.attr("data-activated") === "true") {
      return;
    }
    $element.attr("data-activated", "true");
    return DealHighlights.rotateMessages($element, loopMessages);
  };
  scrollHandler = function(e, $element, loopMessages) {
    if ($(this).scrollTop() > 0) {
      $(this).off(e);
      return activateRotatingMessaging($element, loopMessages);
    }
  };
  bindHighlightLinksNavigation = function(id) {
    var $anchorElement, ref;
    $anchorElement = $(".deal-highlights a[href=\"#" + id + "\"]");
    return (ref = window.TouchDeal) != null ? ref.bindTargetNavigation($anchorElement) : void 0;
  };
  prepareWindowHandlers = function($element, timeout, loopMessages) {
    timeout = timeout || ACTIVATE_PRIMARY_MESSAGE_TIMEOUT;
    window.setTimeout(function() {
      return activateRotatingMessaging($element, loopMessages);
    }, timeout);
    return $(window).on('scroll', function(e) {
      return scrollHandler(e, $element, loopMessages);
    });
  };
  return $(function() {
    var i, len, loopMessages, messageTimer, ref, tile, timerData;
    ref = tiles || [];
    for (i = 0, len = ref.length; i < len; i++) {
      tile = ref[i];
      if (tile.secondaryMessage) {
        messageTimer = tile.messageTimerInSec * 1000;
        loopMessages = tile.loop === true;
        prepareWindowHandlers($('.t-main-inner .deal-highlights, #purchase-cluster .deal-highlights, .multi-option-overlay-cluster .deal-highlights'), messageTimer, loopMessages);
        if ($("#options-pane .deal-highlights").length) {
          window.UrlHashChange.eventBus.board('showHideOptions', function() {
            return prepareWindowHandlers($('#options-pane .deal-highlights'), ACTIVATE_PRIMARY_MESSAGE_TIMEOUT, loopMessages);
          });
        }
      } else if (tile.jsTimerData) {
        timerData = _.extend(tile.jsTimerData, {
          el: '.deal-highlights .countdown-timer',
          translationScope: 'js.modules.groupon-deal-timer.tile'
        });
        CountdownTimer.init({
          timerData: timerData
        });
      }
    }
    bindHighlightLinksNavigation('touch-tips');
    return done();
  });
};

module.exports = DealHighlights;

//# sourceMappingURL=data:application/json;base64,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
